export function hasAliveTerminalGroup(groups: { isAlive?: boolean | null }[]): boolean {
  return groups.some(g => g.isAlive === true);
}

export function pickTerminalGroupId(
  groups: { id: string; isAlive?: boolean | null }[],
  current: string,
): string {
  const alive = groups.filter(g => g.isAlive === true);
  const pool = alive.length > 0 ? alive : groups;
  if (pool.length === 0) return '';
  const trimmed = current?.trim() ?? '';
  if (trimmed && pool.some(g => g.id === trimmed)) return trimmed;
  return pool[0].id;
}
